export default __webpack_public_path__ + "static/media/c.9b0d3fc4.png";